import { TranslationObject } from '@/types/language';

const arabicTranslations: TranslationObject = {
  // Home Screen
  'welcome': 'مرحبا بكم في المتحف',
  'select_tour': 'اختر جولة',
  'search_exhibit': 'البحث عن معرض',
  'visitor_info': 'معلومات للزوار',
  
  // Tour Selection
  'available_tours': 'الجولات المتاحة',
  'view_all_tours': 'عرض كل الجولات',
  
  // Exhibit Access
  'exhibit_access': 'الوصول إلى المعرض',
  'enter_number': 'أدخل رقم المعرض',
  'scan_qr': 'مسح رمز الاستجابة السريعة',
  'view_map': 'عرض على الخريطة',
  'browse_exhibits': 'تصفح المعارض',
  'keypad': 'لوحة المفاتيح',
  'browse_tours': 'تصفح الجولات',
  
  // Exhibit Detail
  'add_to_favorites': 'أضف إلى المفضلة',
  'remove_from_favorites': 'إزالة من المفضلة',
  'share': 'شارك',
  'previous': 'السابق',
  'next': 'التالي',
  'audio_guide': 'دليل صوتي',
  'more_info': 'مزيد من المعلومات',
  
  // Favorites
  'favorites': 'المفضلة',
  'no_favorites': 'لا توجد مفضلات بعد. أضف العروض أثناء استكشافك!',
  
  // Visitor Info
  'opening_hours': 'ساعات العمل',
  'getting_here': 'كيفية الوصول إلينا',
  'contact': 'اتصل بنا',
  'important_links': 'روابط مهمة',
  
  // Accessibility
  'accessibility': 'إمكانية الوصول',
  'font_size': 'حجم الخط',
  'font_size_normal': 'عادي',
  'font_size_large': 'كبير',
  'font_size_extra_large': 'كبير جداً',
  'high_contrast': 'تباين عالي',
  'language': 'لغة',
  'select_language': 'اختر اللغة',
  'accessibility_menu': 'خيارات إمكانية الوصول',
  'toggle_high_contrast': 'تبديل وضع التباين العالي',
  'audio_controls': 'عناصر التحكم في الصوت',
  'playback_speed': 'سرعة التشغيل',
  'volume': 'مستوى الصوت',
  'auto_play_audio': 'تشغيل تلقائي للصوت',
  'toggle_auto_play': 'تبديل التشغيل التلقائي',
  
  // Navigation
  'home': 'الرئيسية',
  'tours': 'جولات',
  'exhibits': 'معروضات',
  'info': 'معلومات',
  'map': 'خريطة',
  'list': 'قائمة',
  
  // General
  'loading': 'جاري التحميل...',
  'error': 'حدث خطأ ما',
  'back': 'رجوع',
  'play': 'تشغيل',
  'pause': 'إيقاف مؤقت',

  // Search related translations
  'search': 'بحث...',
  'no_results': 'لم يتم العثور على نتائج',
  
  // Welcome Message
  'welcome_message': 'مرحبًا بكم في تطبيق الجولة الصوتية لمتحف آغام. يمكنك استكشاف معارضنا عن طريق إدخال رقم باستخدام لوحة المفاتيح، أو التنقل عبر الجولات المنسقة من القائمة.',
};

export default arabicTranslations;
